module.exports = __webpack_public_path__ + "static/img/exhibitor_top_en.937e89e5.png";